/** One short-lived message at the bottom of the screen, for things the app did
 *  on your behalf that would otherwise happen silently. A newer toast replaces
 *  the one showing rather than queueing behind it. */
import { ref } from "vue";

export const toastMessage = ref<string | null>(null);
let hideTimer: number | null = null;

export function toast(message: string, ms = 2200): void {
  toastMessage.value = message;
  if (hideTimer !== null) window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    toastMessage.value = null;
    hideTimer = null;
  }, ms);
}
